export const SCROLL_CONTAINER_ID = 'scroll-to-top'; //taken from project list providers remote

export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';
export const IMPORT_REMOTE_RUNTIME_EVENT_NAME = 'IMPORT_REMOTE_LOADED';

export const SERVICE_WORKER_CLEAN_CACHE_EVENT_NAME =
  'exo-skeleton:service-worker:clean-cache';

// Emitted by CacheNetworkRace (WPX-4147) when a single fetch handle exceeds
// SLOW_HANDLE_THRESHOLD_MS, so the page can forward timing to Dynatrace — the
// service worker has no `window.dynatrace` of its own to report through.
export const SERVICE_WORKER_SLOW_FETCH_EVENT_NAME =
  'exo-skeleton:service-worker:slow-fetch';

export const MFA_BANNER_SESSION_STORAGE_KEY = 'mfa-setup-banner';

export const REMOTE_LOADING_WARNING_TIMEOUT_MS = 90_000;
export const STATIC_LOADING_WARNING_TIMEOUT_MS = 19_000;

// Self-serve service-worker opt-out for the ?exoSw=on|off override. Shared
// from here so the app and its tests reference one key.
export const SERVICE_WORKER_OVERRIDE_STORAGE_KEY = 'EXO_SW_OVERRIDE';

/* Read from the entry chunk, which must not import `utils/monitoring` — that
 * would pull the monitoring graph into the pre-bootstrap bundle. Re-exported
 * into `REPORT_EVENT_TYPES` so the Dynatrace registry stays complete. */
export const BOOTSTRAP_LOAD_ERROR_EVENT_TYPE = 'bootstrap-load-error';

// One flag per deferred remote, so each rolls out and reverts on its own.
// Shared from here because both root layouts render the trial banner, and the
// e2e coverage needs the same keys to force gating on.
export const DEFER_TRIAL_BANNER_FLAG = 'defer-trial-banner';
export const DEFER_ASSISTANT_IN_TOP_NAV_FLAG = 'defer-assistant-in-top-nav';

// Reported once per deferred remote that IDLE_TIMEOUT_IN_MS released before
// the active tool signaled ready, so a QA measurement can tell the two apart.
// Shared from here because the e2e listens for the same message.
export const DEFERRED_REMOTE_RELEASED_BY_CEILING =
  'deferred-remote-released-by-ceiling';

// used for e2e tests
export const LOCAL_URL = new URL('https://local.acc-qa.autodesk.com:3000/');
